import React, { useState, useEffect } from 'react';
import { Pane, TextInput, NumericInput, ToggleButton, Popup, Button, Flex } from '@leverege/ui-elements';
import i18n from '@leverege/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = i18n.ns('ui-attributes.detail.customText.textEditor.editors.widgets.Image');
export default function ValueEditor(props) {
  const {
    icon,
    onChange,
    initialValue,
    context: {
      editor
    },
    active
  } = props;
  const [src, setSrc] = useState(initialValue.src);
  const [height, setHeight] = useState(initialValue.height);
  const [width, setWidth] = useState(initialValue.width);
  useEffect(() => {
    setSrc(initialValue.src);
    setHeight(initialValue.height);
    setWidth(initialValue.width);
  }, [initialValue]);
  const renderPane = onClose => {
    return /*#__PURE__*/_jsx(Pane, {
      variant: "customTextImageEditor",
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "rowM",
        children: [/*#__PURE__*/_jsx(TextInput, {
          validator: value => value.length < 1000,
          variant: "customTextImageEditor|customText",
          hint: t('hint'),
          value: src,
          onChange: ({
            value
          }) => setSrc(value),
          maxLength: 1001
        }), /*#__PURE__*/_jsx(NumericInput, {
          variant: "customTextImageHeightEditor|customTextImageEditor|customText",
          hint: t('heightHint'),
          value: height,
          onChange: ({
            value
          }) => setHeight(value)
        }), /*#__PURE__*/_jsx(NumericInput, {
          variant: "customTextImageWidthEditor|customTextImageEditor|customText",
          hint: t('widthHint'),
          value: width,
          onChange: ({
            value
          }) => setWidth(value)
        }), /*#__PURE__*/_jsx(Button, {
          variant: "customTextImageEditor|customText",
          onClick: () => {
            onChange({
              src,
              height,
              width
            }, editor);
            onClose();
          },
          children: t('apply')
        })]
      })
    });
  };
  const renderTrigger = ({
    ref,
    onToggle,
    isOpened
  }) => {
    return /*#__PURE__*/_jsx(ToggleButton, {
      title: t('title'),
      variant: "customTextImageEditor|customText",
      value: active,
      onChange: onToggle,
      domRef: ref,
      icon: icon
    });
  };
  return /*#__PURE__*/_jsx(Popup, {
    variant: "customTextImageEditor|customText",
    render: renderPane,
    trigger: renderTrigger
  });
}